export class ProductCardOption extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onClickHandler)
  }

  onClickHandler () {
    if (this.dataset.variantAvailable === 'true') {
      let item = {
        id: this.dataset.variantId,
        quantity: 1,
      }

      if (window?.theme?.filters?.setCollectionGender?.length) {
        item = {
          id: this.dataset.variantId,
          quantity: 1,
          properties: {
            _gender_preference: window.theme.filters.setCollectionGender,
          },
        }
      }

      window.BAO.Cart.addItem(item)
    }
  }
}

customElements.define('product-card-option', ProductCardOption)
